import { AppHelper } from "../../appHelper"
import { AppBaseProps, CommonApp, Context, Entity } from "../../core/components/commonApp";
import { Helper } from "../../core/util/helper";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { General } from "../../../siteManagement/general";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { EventType } from "../../../siteManagement/eventManager";
import { SheetEventType } from "../../../siteManagement/sheet";
import { DialogHelper } from "../../core/util/dialogHelper";
import { Config } from "../../core/config/config";
import { Dialog, DialogProps } from "../../core/components/dialog";
import { StringKeyDictionary } from "../../commonInterfaces";
import React from "react";
import ReactDOM from "react-dom";
export class EmailDataSourceApp extends React.Component<EmailDataSourceProps, { tabId: number }> {
    common = new AppHelper();
    setTabTitle = true;
    translations: StringKeyDictionary<string> = null;
    showExecuteButton: boolean = false;
    disableEntityType: boolean;

    constructor(props) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);
        this.showExecuteButton = false;
        this.disableEntityType = this.props.disableEntityType;
        this.setEvents();
        this.state = {
            tabId: 0
        }
    }

    private setEvents = () => {
        General.Events.bind(EventType.Custom, (data: { cmd: string, data: any }) => {
            switch (data.cmd) {
                case "tabStripTabSelected":
                    //this.showExecuteButton = (data.data.index == 1) && !Helper.isNullOrEmpty(this.props.entity.Content);
                    this.setState({ tabId: data.data.index }, this.checkButtonVisibility)
                    break;
            }
        });
    }

    private checkButtonVisibility = () => {
        this.showExecuteButton = this.state.tabId === 1 && !Helper.isNullOrEmpty(this.props.entity.Content);
        this.setState({})
    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem, this.checkButtonVisibility);
    }

    private validate = () => {
        return ((this.common.validate() as boolean) && this.validateName() && this.validateQuery());
    }

    private validateName = () => {
        const names = this.props.entity.Names;
        const c = Object.keys(names).filter(f => !Helper.isNullOrEmpty(names[f])).length > 0;
        if (c) {
            return true;
        } else {
            NotificationHelper.showWarningMessage(this.translations["WebSMS.ReportMetadata.NameIsMissing"]);
            let el = $("div.tabstrip__content > div:nth-child(2)");
            el.click();
            return false;
        }
    }

    private validateQuery = () => {
        if (Helper.isNullOrEmpty(this.props.entity.Content)) {
            NotificationHelper.showWarningMessage(this.translations["WebCRM.Email.QueryCannotBeEmpty"]);
            let el = $("div.tabstrip__content > div:nth-child(3)");
            el.click();
            return false;
        } else {
            return true;
        }
    }

    save = (closeAfterSave) => {
        if (this.validate()) {
            HTTPService.post<JsonResultClass>("EmailSender/SaveDataSource", this.props.entity)
                .then(result => {
                    if (result.Code === 0) {
                        this.props.entity.Id = result.Data.Id;
                        if (this.props.entity.IsNew) {
                            General.Functions.HistoryState.replaceState("EmailSender/EditDataSource?id=" + encodeURIComponent(this.props.entity.Id));
                        }
                        Helper.updateEntity(this.props.entity, result.Data);
                        NotificationHelper.showSuccessMessage(result.Message);
                    } else {
                        NotificationHelper.showErrorMessage(result.Message);
                    }
                    this.common.handlePostSave(result.Code === 0, closeAfterSave);
                    this.setState({});
                });
        }
    }

    deleteDataSource = async () => {
        let isOK = await DialogHelper.confirm(this.translations["Standard.Msg.Loeschen"]);
        if (isOK) {
            let result = await HTTPService.get<JsonResultClass>("EmailSender/DeleteDataSource?dataSourceId=" + this.props.entity.Id);
            if (result.Code == 0) {
                NotificationHelper.showSuccessMessage(result.Message);
                if (this.common.isWindow) {
                    this.common.sheetWrapper.trigger(SheetEventType.ItemDeleted, this.props.entity);
                    this.common.sheetWrapper.hide();
                } else {
                    this.props.entity.RecordRight.CanWrite = false;
                    this.setState({});
                    setTimeout(() => {
                        window.location.href = Config.baseUrl + "DynamicSearch/emailDataSource";
                    }, 1000);
                }
            } else {
                if (result.Id == "0") {
                    NotificationHelper.showErrorMessage(result.Message);
                } else {
                    let lst = result.AdditionalData["templates"] as string[];
                    let lstString = '<ul style="list-style: disc; padding-left: 17px; margin-top: 5px;">' + lst.map((value) => {
                        return `<li>${value}</li>`
                    }).join('') + "</ul>"
                    const html = (result.AdditionalData["message"] as string).replace("{list}", lstString);
                    const targetElement = $("<div>");
                    $("body").append(targetElement);
                    const dialogProps: DialogProps = {
                        title: "Die Datenquelle kann nicht gelöscht werden",
                        actions: [
                            {
                                label: Config.translations.ok,
                                action: () => {

                                },
                                primary: true
                            }
                        ],
                        afterClose: () => {
                            ReactDOM.unmountComponentAtNode(targetElement[0]);
                            targetElement[0].remove();
                        }
                    };
                    ReactDOM.render(
                        <Dialog {...dialogProps} open={true}>
                            <div>
                                <div dangerouslySetInnerHTML={{ __html: html }}></div>
                            </div>
                        </Dialog >, targetElement[0]);
                }
            }
        }
    }

    executeSQL = () => {
        General.Sheet.Manager.getTopMostSheet().trigger(SheetEventType.Custom, { cmd: "executeSQL" });
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }
}

export interface EmailDataSourceProps extends AppBaseProps {
    entity: EmailDataSourceEntity;
    context: EmailDataSourcePropsContext;
    disableEntityType: boolean;
}

interface EmailDataSourcePropsContext extends Context {
}

export interface EmailDataSourceEntity extends Entity {
    Id: string;
    Names?: {};
    Content: string;
    Type: number;
}